export enum SessionStorageKey {
  DotCaViewedJeunesseContent = "dotca_viewed_jeunesseContent",
  IciTeleTriggeredEngagementEvent = "iciTele_triggeredEngagementEvent",
  IciTeleEngagementData = "iciTele_engagementData",
  OhdioTriggeredEngagementEvent = "ohdio_triggeredEngagementEvent",
  OhdioEngagementData = "ohdio_engagementData",
}
